import React from 'react'
import { SvgIcon } from '@material-ui/core'

function RowViewIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d='M5 10.6247C5 9.81937 5.65289 9.16648 6.45827 9.16648H18.5411C19.3464 9.16648 19.9993 9.81937 19.9993 10.6247V12.708C19.9993 13.5133 19.3464 14.1662 18.5411 14.1662H6.45827C5.65289 14.1662 5 13.5133 5 12.708V10.6247ZM6.24994 10.6247L6.24994 12.708C6.24994 12.823 6.34321 12.9163 6.45827 12.9163H18.5411C18.6561 12.9163 18.7494 12.823 18.7494 12.708V10.6247C18.7494 10.5097 18.6561 10.4164 18.5411 10.4164H6.45827C6.34321 10.4164 6.24994 10.5097 6.24994 10.6247Z'
        fill='#444444'
      />
      <path
        d='M5 4.45782C5 3.65244 5.65289 2.99955 6.45827 2.99955H18.5411C19.3464 2.99955 19.9993 3.65244 19.9993 4.45782V6.54106C19.9993 7.3464 19.3464 7.99929 18.5411 7.99929H6.45827C5.65289 7.99929 5 7.3464 5 6.54106V4.45782ZM6.24994 4.45782V6.54106C6.24994 6.65605 6.34321 6.74938 6.45827 6.74938H18.5411C18.6561 6.74938 18.7494 6.65605 18.7494 6.54106V4.45782C18.7494 4.34274 18.6561 4.24949 18.5411 4.24949H6.45827C6.34321 4.24949 6.24994 4.34274 6.24994 4.45782Z'
        fill='#444444'
      />
      <path
        d='M5 16.9575C5 16.1522 5.65289 15.4993 6.45827 15.4993H18.5411C19.3464 15.4993 19.9993 16.1522 19.9993 16.9575V19.0408C19.9993 19.8461 19.3464 20.499 18.5411 20.499H6.45827C5.65289 20.499 5 19.8461 5 19.0408V16.9575ZM6.24994 16.9575V19.0408C6.24994 19.1558 6.34321 19.2491 6.45827 19.2491H18.5411C18.6561 19.2491 18.7494 19.1558 18.7494 19.0408V16.9575C18.7494 16.8425 18.6561 16.7492 18.5411 16.7492H6.45827C6.34321 16.7492 6.24994 16.8425 6.24994 16.9575Z'
        fill='#444444'
      />
    </SvgIcon>
  )
}

export default RowViewIcon
